'use client';

import { ProductDetailPageProps } from '@/types/ProductDetailPageProps';
import { useState } from 'react';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import RichText from '@/components/RichText';
import { cn } from '@/utilities/cn';
import styles from './ProductInfoTab.module.scss';
import { clsx } from 'clsx';
import ProductInfoDescription from "@/components/ProductAdditionalInfo/ProductInfoDescription";

export default function ProductInfoTab(props: ProductDetailPageProps) {
  const { product } = props;
  const { description, specs, shipping } = product || {};

  const [currentTab, setCurrentTab] = useState<number>(0);

  const { t } = pseudoI18n();

  const tabs = [t('Description'), t('Technical Specifications'), t('Shipping')];

  return (
    <div className={clsx('container mt-6', styles.infoTab)}>
      <ul className="mx-auto flex border-b gap-6 border-neutral-300">
        {tabs.map((tab, index) => (
          <li
            data-text={tab}
            key={index}
            className={cn(
              styles.tab,
              'border-b-2 border-transparent',
              currentTab === index && 'border-black font-bold',
            )}
          >
            <button onClick={() => setCurrentTab(index)} className="py-2 cursor-pointer">
              {tab}
            </button>
          </li>
        ))}
      </ul>
      <div className="mt-6 overflow-x-auto">
        {currentTab === 0 && <ProductInfoDescription description={description} />}
        {currentTab === 1 && <div>{specs && <RichText content={specs} />}</div>}
        {currentTab === 2 && <div>{shipping && <RichText content={shipping} />}</div>}
      </div>
    </div>
  );
}
